<template>
    <NuxtLayout>
        <NuxtRouteAnnouncer />
        <NuxtPage />
    </NuxtLayout>
    <ChatLauncher />
</template>

<script setup lang="ts">
// Outside NuxtLayout so every step of the funnel carries it.
import ChatLauncher from '~/components/ChatLauncher.vue';

useHead({
    title: 'Privacy Bee — Secure Checkout',
});
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.nuxt-loading-indicator {
    display: none !important;
}
</style>
